import { useState } from 'react';

const services = [
  {
    id: 1,
    icon: 'ri-user-heart-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20professional%20caregiver%20in%20light%20green%20uniform%20assisting%20elderly%20patient%20in%20hospital%20bed%2C%20warm%20caring%20expression%2C%20clean%20white%20hospital%20room%2C%20soft%20natural%20light%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=kcsvc1&orientation=landscape',
    title: '간병인 연결 서비스',
    desc: '병원 입원환자를 위한 전문 간병인을 신속하게 연결해 드립니다.',
    items: ['병원 입원환자 24시간 간병', '교대 간병 시스템 운영', '전문 간병인 상담 후 배정', '병원·지역별 맞춤 인력 안내'],
  },
  {
    id: 2,
    icon: 'ri-file-list-3-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20insurance%20claim%20process%20step%20by%20step%20guide%2C%20organized%20medical%20documents%20on%20clean%20white%20desk%2C%20soft%20green%20accent%20colors%2C%20professional%20healthcare%20setting%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=kcsvc2-new&orientation=landscape',
    title: '보험청구 원스톱 지원',
    desc: '간병 시작부터 보험금 수령까지, 4단계 프로세스로 체계적으로 안내해 드립니다.',
    items: ['병원 사전확인 체크리스트 제공', '간병일지 양식 제공 및 작성 안내', '간병 종료 후 정산·증빙 가이드', '보험청구 서류 취합 및 발급 지원'],
  },
  {
    id: 3,
    icon: 'ri-home-heart-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20family%20members%20caring%20for%20elderly%20parent%20at%20home%2C%20warm%20living%20room%20setting%2C%20natural%20light%2C%20loving%20family%20atmosphere%2C%20soft%20warm%20tones%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=kcsvc3&orientation=landscape',
    title: '가족간병 지원 서비스',
    desc: '가족이 직접 간병한 경우에도 보험금 청구에 필요한 서류를 발급해 드립니다.',
    items: ['가족간병 보험 서류 발급', '병원·보험사별 서류 안내', '청구 절차 전문가 지원', '자격 요건 사전 확인'],
  },
  {
    id: 4,
    icon: 'ri-folder-open-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20business%20registration%20certificate%20and%20official%20documents%20being%20issued%20and%20stamped%20on%20clean%20office%20desk%2C%20professional%20atmosphere%2C%20green%20and%20white%20color%20scheme%2C%20organized%20paperwork%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=kcsvc4-new&orientation=landscape',
    title: '증빙서류 발급 서비스',
    desc: '보험청구에 필요한 회사 발급 서류 3종을 신속하게 발급해 드립니다.',
    items: ['이용내역 확인서 발급', '회원가입 사실확인서 발급', '사업자등록증 제공', '간병일지 공식 양식 다운로드'],
  },
];

export default function ServiceDetailSection() {
  const [active, setActive] = useState(0);
  const svc = services[active];

  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: '#2E7D6B' }}>OUR SERVICES</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">코리아케어러스 주요 서비스</h2>
          <p className="text-sm text-gray-500 mt-2">가족간병 등록부터 보험 청구 서류까지, 함께 도와드립니다</p>
        </div>

        {/* Tab + Content - 간병이지와 완전히 다른 탭 인터랙션 방식 */}
        <div className="flex flex-col md:flex-row gap-8 items-start">
          {/* Left: Tab list */}
          <div className="w-full md:w-64 flex-shrink-0 flex flex-row md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-2 md:pb-0">
            {services.map((s, i) => (
              <button
                key={s.id}
                onClick={() => setActive(i)}
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-left whitespace-nowrap md:whitespace-normal cursor-pointer transition-all flex-shrink-0 md:flex-shrink w-full"
                style={{
                  backgroundColor: active === i ? '#2E7D6B' : '#f4faf8',
                  color: active === i ? '#fff' : '#374151',
                  border: active === i ? 'none' : '1px solid #e8f5f1',
                }}
              >
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0"
                  style={{ backgroundColor: active === i ? 'rgba(255,255,255,0.2)' : '#e8f5f1' }}
                >
                  <i className={`${s.icon} text-sm`} style={{ color: active === i ? '#fff' : '#2E7D6B' }}></i>
                </div>
                <span className="text-sm font-semibold">{s.title}</span>
              </button>
            ))}
          </div>

          {/* Right: Content */}
          <div className="flex-1 rounded-2xl overflow-hidden border border-gray-100">
            <div className="w-full h-56 md:h-72 overflow-hidden">
              <img
                key={svc.id}
                src={svc.img}
                alt={svc.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#e8f5f1' }}>
                  <i className={`${svc.icon} text-lg`} style={{ color: '#2E7D6B' }}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{svc.title}</h3>
              </div>
              <p className="text-sm text-gray-500 mb-4 leading-relaxed">{svc.desc}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {svc.items.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#e8f5f1' }}>
                      <i className="ri-check-line text-xs" style={{ color: '#2E7D6B' }}></i>
                    </div>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
